<template>
	<v-hover v-slot:default="{ hover }" close-delay="600">
		<v-list-item dense class="px-2" :link="link" :to="href" @click="click">
				<v-list-item-icon class="mr-4">
					<v-icon :color="iconcolor || 'grey'">{{icon}}</v-icon>
					<v-badge v-if="badge" :content="badge" color="accent"></v-badge>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title class="font-weight-medium">{{name}}</v-list-item-title>
					<v-list-item-subtitle class="font-weight-light" v-if="description">{{description}}</v-list-item-subtitle>
				</v-list-item-content>
				<v-list-item-icon>
					<template v-if="tooltip">	
						<FancyTooltip :title="name" :on="hover">
							<template v-slot:content>
								<slot name="tooltip"></slot>
							</template>
						</FancyTooltip>
					</template>
				</v-list-item-icon>
		</v-list-item>
	</v-hover>
</template>

<script type="text/javascript">

	import FancyTooltip from "@/components/elements/FancyTooltip"
	export default {
		name: "NavigationItem", 
		props: ["icon", "name", "type", "badge", "to", "description", "iconcolor", "tooltip"],
		computed: {
			link(){
				if( this.type == "link" ){
					return true;
				}
				return false;
			},
			href(){
				if( this.type == "link" ){
					return `/${this.to}`
				}
				return null;
			}
		},
		data: () => {
			return {
				// hovering: false, 
				// show_icon: false
			}
		},
		methods: {
			click(){
				if( this.type == "click" ){
					this.$emit("click");
				}
			}
		},
		watch: {
			// hover(){
			// 	var self = this;
			// 	if( self.hovering == true ){
			// 		self.show_icon = true;
			// 	}
			// 	else{
			// 		setTimeout( function(){
			// 			if( self.hovering == false ){
			// 				self.show_icon = false;
			// 			}
			// 		}, 500 )
			// 	}
			// }
		},
		components: {
			FancyTooltip
		}
	}
</script>